export { default } from "./PostTextAndMedia";
